export default {
  baseURL: 'https://traking-api.iryka.com/',
  // baseURL: 'http://localhost:8003/',
  createClient: 'clients',
  getClient: 'clients',
  getOneClient: 'clients',
  patchUpdateClient: 'clients',
  getAllCampagn: 'campagnes',
  getCampagn: 'campagnes',
  createCampagn: 'campagnes',
  findOneCampagn: 'campagnes/findBy',
  getCommercial: 'auth/commercial',
  createCommercial: 'auth/commercial/register',
  getAffectations: 'affectations',
  createAffectations: 'affectations/batch',
  getRecensements: 'recensements',
  getVentes: 'ventes',
  getRetours: 'retours',
  createPrestataire: 'auth/commercial/register/prestataire',
  createKillometrage: 'kilometrage'
}
